import { useUserPermissions } from "@saleor/auth/hooks/useUserPermissions";
import { getPreviewOrderFilterTable } from "@saleor/createOrder/views/sort";
import {
  PermissionEnum,
  PreviewDomesticOrderQuery,
  usePreviewDomesticOrderLazyQuery
} from "@saleor/graphql";
import useNotifier from "@saleor/hooks/useNotifier";
import { useEffect, useMemo, useState } from "react";

export const useDataPreview = (id, params, valuesPaginationState, settings) => {
  const [dataPreview, setDataPreview] = useState<PreviewDomesticOrderQuery>();
  const [loadingPreviewOrder, setLoadingPreviewOrder] = useState<boolean>(true);
  const permissions = useUserPermissions();
  const notify = useNotifier();
  const extensionsPermissionDomestic = permissions?.find(
    perm => perm.code === PermissionEnum.VIEW_ORDER_DOMESTIC
  );
  const queryVariables = useMemo(
    () => ({
      id,
      ...valuesPaginationState,
      sortBy: getPreviewOrderFilterTable(params)
    }),
    [settings.rowNumber, valuesPaginationState, params, id]
  );

  const [
    getPreviewDomesticOrder,
    { data: dataPreviewDomesticOrder }
  ] = usePreviewDomesticOrderLazyQuery({
    fetchPolicy: "no-cache",
    onError: error => {
      notify({
        status: "error",
        apiMessage: error.message
      });
    }
  });

  useEffect(() => {
    if (extensionsPermissionDomestic) {
      getPreviewDomesticOrder({
        variables: queryVariables
      });
    }
  }, [queryVariables]);

  useEffect(() => {
    if (dataPreviewDomesticOrder) {
      setDataPreview(dataPreviewDomesticOrder);
      setLoadingPreviewOrder(false);
      return;
    }
  }, [dataPreviewDomesticOrder]);

  return {
    dataPreview,
    loadingPreviewOrder
  };
};
